import { useQuery } from '@tanstack/react-query';

import { profileClient } from '~sf/api/clients';
import { QueryKey } from '~sf/api/query';

import useStore from './useStore';

const useProfile = () => {
  const { loggedIn } = useStore((state) => ({
    loggedIn: state.loggedIn,
  }));

  const { data: profile } = useQuery({
    queryKey: QueryKey.Profile,
    queryFn: async () => profileClient({}),
    staleTime: 100,
    enabled: loggedIn,
  });

  return profile?.data;
};

export default useProfile;
